<template>
	<div id="popcoupon">
    <button
      type="button"
      class="btn btn-primary pull-right"
      @click="showModal"
    >
    {{ text }}
    </button>

    <ModalCoupon ref="modalcoupon"
      v-show="isModalVisible"
      v-bind:next="next"
      v-bind:sign="sign"
      v-bind:accept="accept"
      v-bind:name="name"
      v-bind:text="text"
      @close="closeModal"
    />
  </div>
</template>

<script>
import ModalCoupon from './components/modal_coupon.vue'

export default {
	components: {
    ModalCoupon,
	},
  props: ["name", "next", "text", "sign", "accept"],
  data() {
    return {
      isModalVisible: false,
    }
  },
  methods: {
    submit(){
      console.log(this);
    },
    showModal() {
     window.jQuery(this.$refs.modalcoupon.$el).modal('show')
     this.isModalVisible = true;
    },
    closeModal() {
     window.jQuery(this.$refs.modalcoupon.$el).modal('hide')
     this.isModalVisible = false;
    },
  }
}
</script>

<style lang="scss">

*, *::before, *::after {
	box-sizing: border-box;
}

#popcoupon {
	margin: 0 auto;
	line-height: 1.4;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: blue;
}

h1 {
	text-align: center;
}
</style>
